import {PhoneNumberUtil} from 'libphonenumber';

const phoneUtils = PhoneNumberUtil.getInstance();

const PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

class PolicyContactsCtrl {

    constructor(InsuranceSuiteMetadata, $filter, defaultLocaleDetails) {
        this._rolesTypeList = InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyContactRole');
        this._filter = $filter;
        this._defaultLocaleDetails = defaultLocaleDetails;
    }

    getPrimaryPhoneNumber(contact) {
        const phoneNumber = contact[PRIMARY_PHONE_TYPE_MAP[contact.primaryPhoneType]];
        if (!phoneNumber) return null;
        try {
            return phoneUtils.formatNational(phoneNumber, this._defaultLocaleDetails.countryCode);
        } catch (e) {
            return phoneNumber;
        }
    }

    // noinspection JSUnusedGlobalSymbols
    getRoleName(roleCode) {
        return this._filter('translate')(`gateway.contacts.common.views.policy.roles.${this._rolesTypeList.getCode(roleCode).name}`);
    }
}

PolicyContactsCtrl.$inject = ['InsuranceSuiteMetadata', '$filter', 'defaultLocaleDetails'];

export default PolicyContactsCtrl;

